import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: 'Does this work for any country?',
  answer: "Yes. This is an 'Operating System' for decision making, not a directory of local phone numbers. The traps, pressure tactics, and organizational needs are universal whether you're moving to London, Berlin, or Bali. We teach you HOW to handle the system, which works everywhere."
}, {
  question: "I've already been here for a month. Is it too late?",
  answer: "Not at all. While it's designed for the first 14 days, the 'Proof Library' and dispute scripts are valuable anytime. If you haven't signed a long-term lease yet, you absolutely need this before you do."
}, {
  question: 'Is this a physical product?',
  answer: "No, it is a digital kit (PDFs, Notion templates, and mobile-friendly checklists) that you can access immediately on your phone or laptop. We know you don't want to carry more physical baggage."
}, {
  question: "What if I don't like it?",
  answer: "We offer a 30-day money-back guarantee. If you feel it didn't help you settle in with more confidence, just email us and we'll refund your $37 immediately."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 bg-[#FAF8F6] border-t border-neutral-200" data-id="element-27">
      <div className="max-w-2xl mx-auto" data-id="element-28">
        <h2 className="text-3xl font-bold text-center text-neutral-900 mb-12 font-serif" data-id="element-29">
          Common Questions
        </h2>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <div key={index} className="border border-neutral-200 rounded-lg overflow-hidden" data-id="element-31">
              <button className="w-full flex items-center justify-between p-5 text-left bg-[#F5F0EB] hover:bg-[#EDE8E3] transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-32">
                <span className="font-medium text-neutral-900 pr-4" data-id="element-33">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="h-5 w-5 text-neutral-500 flex-shrink-0" data-id="element-34" /> : <ChevronDown className="h-5 w-5 text-neutral-500 flex-shrink-0" data-id="element-35" />}
              </button>

              <AnimatePresence data-id="element-36">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-37">
                    <div className="p-5 bg-[#FAF8F6] text-neutral-600 leading-relaxed border-t border-neutral-100" data-id="element-38">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}